import { AccessResult } from "utils/access";

export const TEMPLATE_DEPLOYMENT_MESSAGE =
  "This stack can't be modified because it was created from a template deployment.";

type StackWithTemplateDeployment = {
  isLockedByTemplateDeployment: boolean;
};

export const checkTemplateDeploymentAccess = (
  stack?: StackWithTemplateDeployment
): AccessResult | undefined => {
  if (stack?.isLockedByTemplateDeployment) {
    return { result: false, message: TEMPLATE_DEPLOYMENT_MESSAGE };
  }
  return undefined;
};
